var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"back-button ion-ios-arrow-left",on:{"!click":function($event){return _vm.goBack($event)}}},[_vm._v("\n  "+_vm._s(_vm.$t('GENERAL_SETTINGS.BACK'))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }